import "./index.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.sort");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _constant = require("../_utils/constant.js");

var _Icon = _interopRequireDefault(require("../Icon"));

var _request = _interopRequireDefault(require("../request"));

var _config = _interopRequireDefault(require("../config"));

var _Popover = _interopRequireDefault(require("../Popover"));

require("../Select");

var _component = require("../_utils/component");

var _User = _interopRequireDefault(require("./User"));

var _Search = _interopRequireDefault(require("./Search"));

var _Link = _interopRequireDefault(require("./Link"));

var _templatesPopover = _interopRequireDefault(require("./templates-popover"));

var _url = require("../_utils/url");

var _searchHistory = _interopRequireDefault(require("./search-history"));

var _createVideo = _interopRequireDefault(require("../createVideo"));

var _vueNormalizeComponent = _interopRequireDefault(require("../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var scenes = [{
  label: '新媒体频道',
  value: '/xinmeiti'
}, {
  label: '电商频道',
  value: '/dianshang'
}, {
  label: '人力行政频道',
  value: '/qiye'
}];
var __vue_script__ = {
  name: (0, _component.createComponentName)('header'),
  components: {
    Icon: _Icon.default,
    Popover: _Popover.default,
    User: _User.default,
    Search: _Search.default,
    GdLink: _Link.default,
    TemplatesPopover: _templatesPopover.default
  },
  mixins: [_component.componentMixin],
  props: {
    // 当前页面的域名, 会将相同域名的地址转换为相对路径
    host: {
      type: String,
      default: _config.default.host
    },
    // 半透明 用于专题页
    translucent: {
      type: Boolean,
      default: false
    },
    // 是否登录
    isLogined: {
      type: Boolean,
      default: false
    },
    // 处理导航数据
    handleNavigations: {
      // (navs: object[]) => object[]
      type: Function,

      default() {}

    },
    // 触发退出
    logout: {
      type: Function,
      required: true
    },
    // 触发登录
    login: {
      type: Function,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      scenes,
      visible: false,
      query: '',
      scrollTop: 0,
      mounted: false,
      suggestions: [],
      searchHistory: {},
      hots: []
    };
  },

  computed: {
    isPindao() {
      return this.$route.path === '/xinmeiti' || this.$route.path === '/dianshang' || this.$route.path === '/qiye';
    },

    isShowSarch() {
      if (this.$route.path.indexOf('templates') > -1) {
        if (this.scrollTop > 328) {
          return true;
        }

        return false;
      }

      return true;
    }

  },

  created() {
    // this.resetData(false);
    this.fetchHots();
    this.initHistory();
    this.fetchSuggest = (0, _throttle.default)(this.fetchSuggest, 300);
  },

  mounted() {
    this.mounted = true;
    window.addEventListener('scroll', this.listenerScroll, false);
    this.listenerScroll();
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.listenerScroll, false);
  },

  methods: {
    createVideo: _createVideo.default,

    listenerScroll() {
      this.scrollTop = document.documentElement.scrollTop;
    },

    cogradientHistory() {
      var _this = this;

      return (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var postData, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                postData = [];
                data = (0, _searchHistory.default)(10, 'search_history');

                if (!(data.list.length !== 0)) {
                  _context.next = 6;
                  break;
                }

                postData = data.list.sort(function (a, b) {
                  return (a.timestamp || 0) - (b.timestamp || 0);
                }).map(function (item) {
                  return {
                    result_num: item.result_num ? item.result_num.toString() : '0',
                    search_word: item.search_word,
                    roles: item.roles ? item.roles.toString() : '0',
                    colors: item.colors || '0',
                    categories: item.categories || '0',
                    is_corrected: 0
                  };
                });
                _context.next = 6;
                return _request.default.post('/api/search-records', postData).then(function (res) {
                  _this.searchHistory.list = res.data.sort(function (a, b) {
                    return b.id - a.id;
                  });
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    delHistory(item) {
      var _this2 = this;

      if (this.isLogined) {
        return _request.default.put("/api/search-records/" + (item.id || 0), {
          is_all: 0 // 清除当前id

        }).then(function () {
          // this.searchHistory.list = this.searchHistory.list.filter(item => item.id !== res.data.id);
          _this2.getSearchRecordsList(true);
        }).catch(function (err) {
          return console.log(err);
        });
      } else {
        this.searchHistory.remove(item);
      }
    },

    clearHistory() {
      var _this3 = this;

      if (this.isLogined) {
        return _request.default.put('/api/search-records/0', {
          is_all: 1
        }).then(function () {
          _this3.searchHistory.list = []; // this.searchHistory.clear();
          // this.searchHistory.save();
        }).catch(function (err) {
          return console.log(err);
        });
      } else {
        this.searchHistory.clear();
        this.searchHistory.save();
        this.initHistory();
      }
    },

    initHistory(noCogradient) {
      if (noCogradient === void 0) {
        noCogradient = true;
      }

      var SEARCH_HISTORY = 'search_history';
      var MAX_HISTORY_LENGTH = 10;
      this.searchHistory = (0, _searchHistory.default)(MAX_HISTORY_LENGTH, SEARCH_HISTORY);

      if (this.isLogined) {
        this.getSearchRecordsList(noCogradient);
      }
    },

    getSearchRecordsList(noCogradient) {
      var _this4 = this;

      if (noCogradient === void 0) {
        noCogradient = false;
      }

      return _request.default.get('/api/search-records', {}).then(
      /*#__PURE__*/
      function () {
        var _ref = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(res) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(res.data && res.data.length !== 0)) {
                    _context2.next = 4;
                    break;
                  }

                  _this4.searchHistory.list = res.data;
                  _context2.next = 8;
                  break;

                case 4:
                  _this4.searchHistory.list = [];

                  if (noCogradient) {
                    _context2.next = 8;
                    break;
                  }

                  _context2.next = 8;
                  return _this4.cogradientHistory();

                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (err) {
        return console.log(err);
      });
    },

    // @vuese
    // 重置导航数据， 登录后需要使用，获取不同的灰度数据
    resetData(noInit) {
      if (noInit === void 0) {
        noInit = true;
      }

      // request.get('/api/navigations').then(res => {
      //     cache.localCache.set('navigations', res.data);
      //     if (this.handleNavigations) {
      //         res.data = this.handleNavigations(res.data) || res.data;
      //     };
      //     this.navs = res.data;
      // });
      this.initHistory(!noInit);
    },

    fetchHots() {
      var _this5 = this;

      return _request.default.get('/api/search-hot-words', {}).then(
      /*#__PURE__*/
      function () {
        var _ref2 = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee3(res) {
          var hotsData;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  hotsData = res.data;
                  _this5.hots = hotsData;

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (err) {
        _this5.hots = [];
        throw err;
      });
    },

    fetchSuggest() {
      var _this6 = this;

      if (!this.query) {
        this.suggestions = [];
        return;
      }

      ;

      _request.default.get('/api/suggest', {
        params: {
          q: this.query
        }
      }).then(function (res) {
        _this6.suggestions = res.data.filter(function (k) {
          return k !== _this6.query;
        }).slice(0, 5);
      });
    },

    onClick(nav) {
      // 点击导航触发
      // @arg nav: object
      this.$emit('select', nav);
    },

    transformUrl(url) {
      return (0, _url.toRelativePath)(url, this.host);
    },

    search() {
      var href = _constant.REQUEST_URL + "/templates?q=" + this.query;
      location.href = href;
    }

  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    class: _vm.bem("wrapper")
  }, [_c("header", {
    class: _vm.bem()
  }, [_c("div", {
    class: _vm.bem("nav")
  }, [_c("div", {
    class: _vm.bem("content")
  }, [_c("GdLink", {
    class: _vm.bem("gd-logo"),
    attrs: {
      url: "/",
      title: "返回首页"
    }
  }, [_c("div", {
    class: _vm.bem("logo")
  }, [_c("Icon", {
    attrs: {
      name: "logo"
    }
  })], 1)]), _vm._v(" "), _vm.scenes.findIndex(function (s) {
    return _vm.$route.path === s.value;
  }) > -1 ? _c("div", {
    class: _vm.bem("channel")
  }, [[_c("div", {
    class: _vm.bem("divider")
  }), _vm._v(" "), _c("h3", [_vm._v(_vm._s(_vm.scenes.find(function (s) {
    return _vm.$route.path === s.value;
  }).label))])]], 2) : _vm._e(), _vm._v(" "), _c("div", {
    class: _vm.bem("nav-list")
  }, [_c("span", {
    class: _vm.bem("nav-item", {
      routeActive: _vm.$route.path === "/"
    }),
    on: {
      click: function click($event) {
        return _vm.$router.push("/");
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c("TemplatesPopover", {
    class: _vm.bem("nav-item")
  }, [_c("GdLink", {
    attrs: {
      url: "/templates"
    }
  }, [_vm._v("\n                            模板中心\n                        ")])], 1), _vm._v(" "), _c("Popover", {
    class: _vm.bem("nav-item"),
    attrs: {
      visible: _vm.visible,
      delayonMouseLeave: 100,
      appendBody: false,
      modifiers: {
        offset: {
          offset: "0 10px"
        }
      }
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      },
      click: function click($event) {
        _vm.visible = false;
      }
    }
  }, [_c("GdLink", {
    class: {
      routeActive: _vm.isPindao
    },
    attrs: {
      url: "/xinmeiti"
    }
  }, [_vm._v("\n                            特色频道\n                        ")]), _vm._v(" "), _c("div", {
    staticStyle: {
      width: "120px",
      padding: "8px 0"
    },
    attrs: {
      slot: "content"
    },
    slot: "content"
  }, _vm._l(_vm.scenes, function (ref) {
    var value = ref.value;
    var label = ref.label;
    return _c("div", {
      key: value,
      class: ["gd-select-option", {
        "gd-select-option--is-active": value === _vm.$route.path
      }],
      on: {
        click: function click() {
          _vm.visible = false;
        }
      }
    }, [_c("GdLink", {
      class: "gd-select-option__content",
      attrs: {
        url: value
      }
    }, [_vm._v("\n                                    " + _vm._s(label) + "\n                                ")])], 1);
  }), 0)], 1), _vm._v(" "), _c("GdLink", {
    class: _vm.bem("nav-item"),
    attrs: {
      url: "/topics"
    }
  }, [_vm._v("\n                        专题/套装\n                    ")]), _vm._v(" "), _c("GdLink", {
    class: _vm.bem("nav-item"),
    attrs: {
      url: "/download"
    }
  }, [_vm._v("\n                        手机版\n                    ")]), _vm._v(" "), _c("div", {
    class: _vm.bem("divider")
  }), _vm._v(" "), _c("GdLink", {
    key: "智能拼图",
    class: _vm.bem("nav-item"),
    attrs: {
      url: "/koutu"
    }
  }, [_vm._v("\n\n                        智能抠图\n                    ")])], 1), _vm._v(" "), _c("div", {
    class: _vm.bem("right")
  }, [_c("div", {
    staticStyle: {
      flex: "1 1 auto"
    }
  }), _vm._v(" "), _vm.isShowSarch ? _c("Search", {
    attrs: {
      options: _vm.suggestions,
      searchHistory: _vm.searchHistory.list || [],
      hots: _vm.hots
    },
    on: {
      search: _vm.search,
      input: _vm.fetchSuggest,
      "del-history": _vm.delHistory,
      "clear-history": _vm.clearHistory
    },
    model: {
      value: _vm.query,
      callback: function callback($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  }) : _vm._e(), _vm._v(" "), _c("img", {
    class: _vm.bem("novice"),
    attrs: {
      src: require("./assets/video.png"),
      srcset: require("./assets/video2x.png") + " 2x",
      alt: "新手教程"
    },
    on: {
      click: function click($event) {
        return _vm.createVideo({
          url: "https://st-gdx.dancf.com/gaodingx/8/configs/system/20190430-220520-f572.mp4",
          autoplay: true
        });
      }
    }
  }), _vm._v(" "), _c("User", {
    attrs: {
      isLogined: _vm.isLogined,
      logout: _vm.logout,
      login: _vm.login,
      user: _vm.user
    }
  }, [_vm._t("nick")], 2)], 1)], 1)])])]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default;